import React, { Component } from 'react'
import FaPlay from 'react-icons/lib/fa/play'
import { browserHistory, Link } from 'react-router'
import FaExclamationTriangle from 'react-icons/lib/fa/exclamation-triangle'
import VideoProgress from '../../../misc/videoProgress/VideoProgress.js'
import VideoUrl from './VideoUrl'
import VideoActionButtons from './VideoActionButtons'
import { getBestSourceUrl } from '../../../misc/utilities'
import './videoItem.css'
import { createAction } from 'redux-actions'
import { cancel, ZOOM } from '../../../actions'
import MdMovie from 'react-icons/lib/ti/scissors'
import FaTrash from 'react-icons/lib/fa/trash'
import FaCode from 'react-icons/lib/fa/code'
import MdGraph from 'react-icons/lib/md/insert-chart'
import DownloadIcon from 'react-icons/lib/md/file-download'
import DropDown from '../../../misc/dropdown/DropDown'
import Checkbox from 'rc-checkbox'
import Textarea from 'react-textarea-autosize'
import moment from 'moment'
import '../../../misc/rc-checkbox.css'

function nFormatter(num, digits) {
  var si = [
    { value: 1E18, symbol: "E" },
    { value: 1E15, symbol: "P" },
    { value: 1E12, symbol: "T" },
    { value: 1E9,  symbol: "G" },
    { value: 1E6,  symbol: "M" },
    { value: 1E3,  symbol: "k" }
  ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/, i;
  for (i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
    }
  }
  return num.toFixed(digits).replace(rx, "$1");
}

export default class GridItem extends Component {
  constructor() {
    super()

    this.state = {
      clipped: false,
    }
  }
  
  render() {
    const {
      props,
      toggleDeleteModal,
      toggleSelect,
      toggleEmbedModal,
      children,
      onTitleChange,
      isMobile,
    } = this.props

    // override this here because we don't want it to adjust size on change, only on props change
    function textAreaChange(e) {
      this.props.onChange(e)
    }
    Textarea.prototype._onChange = textAreaChange

    let dropdownItems = [
      {
        onClick: (e) => {
          browserHistory.push(`/stats/${props.video.shortcode}`)
        },
        icon: <MdGraph />,
        title: 'Stats',
        description: 'Plays over time and top embedders',
      }
    ]
    if (!props.video.source_url || !props.video.source_url.includes('nodownloadsource')) {
      dropdownItems.push({
        onClick: (e) => {
          const file_path = `https://${getBestSourceUrl(props.video)}`
          const a = document.createElement('A');
          a.href = file_path;
          a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        },
        icon: <DownloadIcon />,
        title: 'Download',
        description: 'Save a high quality version to your device',
      })
    }
    dropdownItems.push({
        onClick: (e) => {
          toggleDeleteModal()
        },
        icon: <FaTrash />,
        title: 'Delete',
        description: 'Purge this video and its metadata',
    })

    return (
      <div
        className={
          `${props.reorderable ? 'reorderable' : ''} ${props.selected ? 'selected' : ''} col-lg-4 col-md-6 col-sm-12 col-12 grid video-item`
        }
      >
        {props.video.status === 3
          ? <div className="error-alert">
            <FaExclamationTriangle />
            <p>{props.video.error}<br />{props.video.original_name}</p>
            <button
              onClick={(e) => {
                props.dispatch(cancel(props.video))
              }}
            >
                OK
              </button>
          </div>
          : <div>
            {children}
            <div className="card">
              <div
                className="video-thumbnail-container"
              >
                {(() => {
                  switch (props.video.status) {
                    case undefined:
                    case null:
                    case 0:
                    case 1:
                      return <VideoProgress video={props.video} />
                    case 2:
                      return (
                        <div
                          className="play-button"
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => {
                            if (e.ctrlKey || e.shiftKey) {
                              e.preventDefault()
                              return true
                            }

                            if (props.video.status === 2) {
                              props.dispatch(createAction(ZOOM)(props.video))
                            }

                            e.stopPropagation()
                            return false
                          }}
                        >
                          <FaPlay />
                        </div>
                      )
                    default:
                      return <div />
                  }
                })()}

                {props.video.thumbnail_url
                    ? <img
                      className="card-img-top"
                      role="presentation"
                      src={props.video.thumbnail_url}
                    />
                    : <div className="card-img-top" />}
                {props.video.poster_url
                    ? <img
                      src={props.video.poster_url}
                      style={{ display: 'none' }}
                    />
                : ''}
                <div className="video-header">
                  <Checkbox
                    checked={props.selected}
                    onChange={toggleSelect}
                    className="video-item-checkbox"
                  />
                  {props.video.status === 2 ?
                    <Link className="header-item float-right" to={`/stats/${props.video.shortcode}`} onClick={(e) => {
                      e.stopPropagation()
                    }}>
                      {nFormatter(props.video.plays, 0)} view{props.video.plays === 1 ? '' : 's'}
                    </Link>
                  : ''}
                </div>
              </div>
              <div className="card-block">
                <div className="card-metadata">
                  <Textarea
                    className="form-control edit-title-input"
                    maxLength="200"
                    placeholder="Add a title"
                    value={props.video.title}
                    onChange={(e) => { 
                      // check for line break
                      const match = /\r|\n/.exec(e.target.value);
                      if (match) {
                        onTitleChange(e.target.value.replace(/(\r\n|\n|\r)/gm,""), true)
                        e.target.blur()
                        return false
                      } 
                      onTitleChange(e.target.value)
                    }}
                  />
                  <VideoUrl {...props.video} />
                </div>
              </div>
              <div className="card-footer">
                {props.video.status === 2 ?
                  <DropDown
                    position="bottom left"
                    className="float-left action-button-dropdown"
                    items={dropdownItems}
                  >
                    <span>…</span>
                  </DropDown>
                : ''}
                <VideoActionButtons
                  className="float-right"
                  video={props.video}
                  dispatch={props.dispatch}
                  toggleDeleteModal={toggleDeleteModal}
                  toggleEmbedModal={toggleEmbedModal}
                  group={props.group}
                />
              </div>
            </div>
          </div>}
      </div>
    )
  }
}
